import { useState, useEffect, useRef } from 'react'
import { useMediaQuery } from '@mantine/hooks'

const LazyLoadSection = ({
  children,
  height = 200,
  mobileHeight = 200,
  ...props
}: {
  children: React.ReactNode
  height?: number
  mobileHeight?: number
  [key: string]: any
}) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [dummyHeight, setDummyHeight] = useState<number>(isMobile ? mobileHeight : height)
  const sectionRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0 },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    if (sectionRef.current) {
      const style = window.getComputedStyle(sectionRef.current)
      const pt = parseInt(style.paddingTop)
      const pb = parseInt(style.paddingBottom)
      const mt = parseInt(style.marginTop)
      const mb = parseInt(style.marginBottom)
      const h = isMobile ? mobileHeight : height

      setDummyHeight(h - (pt + pb + mt + mb))
    }
  }, [sectionRef, isMobile])

  return (
    <section ref={sectionRef} {...props}>
      {isVisible ? children : <div style={{ height: dummyHeight }} />}
    </section>
  )
}

export default LazyLoadSection
